import logo from '../assets/logo.png'
import email from '../assets/email.png'
import mobile from '../assets/mobile.png'
import aboutinfobg from '../assets/about_info_left-bg.png'
import upwork from '../assets/upwork_logo.svg'
import freelancer from '../assets/freelancer_logo.svg'
import fiver from '../assets/fiver_logo.svg'
import work from '../assets/work.png'
import about_img1 from '../assets/Homepage_2/Image_1.png'
import about_img2 from '../assets/Homepage_2/Image_2.jpg'
import about_img3 from '../assets/Homepage_3/Image_1.jpg'
import about_img4 from '../assets/Homepage_3/Image_2.jpg'
import exclusive_service_img1 from '../assets/Homepage_4/Image_1.png'
import exclusive_service_img2 from '../assets/Homepage_4/Image_2.png'
import exclusive_service_img3 from '../assets/Homepage_4/Image_3.jpg'
import exclusive_service_img4 from '../assets/Homepage_4/Image_4.jpg'
import experience_img1 from '../assets/Homepage_5/Image_1.jpeg'
import service_img_3 from '../assets/Services_Page/3D_Modeling_Rendering.jpg'
import service_img_1 from '../assets/Services_Page/Architectural.jpg'
import service_img_2 from '../assets/Services_Page/Interior_Design.jpg'
import service_img_4 from '../assets/Services_Page/Revit_BIM.jpg'
import architectural_portfolio from '../assets/Projects_Pages/Facade_Design.png'
import backgroud_img from '../assets/bgimage.jpg'
import interior_portfolio from '../assets/Bedroom.png'
import revit_portfolio from '../assets/revit.jpg'
import Fiverr_Review_Christos_Sparta from '../assets/Testimonials/Fiverr_Review_Christos_Sparta.jpg';
import Fiverr_Review_Darryl_Wyliefrom from'../assets/Testimonials/Fiverr_Review_Darryl_Wylie.jpg';
import Linkedin_Review_Lulu_Loganfrom from '../assets/Testimonials/Linkedin_Review_Lulu_Logan.PNG';
import Linkedin_Review_Rafsaan_Rubail from '../assets/Testimonials/Linkedin_Review_Rafsaan_Rubail.PNG';
import Upwork_Review_Ehud_Sourjon from '../assets/Testimonials/Upwork_Review_Ehud_Sourjon.PNG';
import Upwork_Review_MO_Ali from '../assets/Testimonials/Upwork_Review_MO_Ali.PNG';
import linkedin from '../assets/linkedin-.avif'
import Character_1 from '../assets/character_1.jfif'
import Character_2 from '../assets/character_2.jfif'
import Character_3 from '../assets/character_3.jfif'
import Character_4 from '../assets/character_4.jfif'
import founder from '../assets/founder.jpg'
import co_founder from '../assets/co-founder.jpeg'

export default {
  logo,
  email,
  mobile,
  aboutinfobg,
  upwork,
  freelancer,
  fiver,
  about_img1,
  about_img2,
  about_img3,
  about_img4,
  exclusive_service_img1,
  exclusive_service_img2,
  exclusive_service_img3,
  exclusive_service_img4,
  experience_img1,
  service_img_1,
  service_img_2,
  service_img_3,
  service_img_4,
  work,
  architectural_portfolio,
  backgroud_img,
  interior_portfolio,
  revit_portfolio,
  Fiverr_Review_Christos_Sparta,
  Fiverr_Review_Darryl_Wyliefrom,
  Linkedin_Review_Lulu_Loganfrom,
  Linkedin_Review_Rafsaan_Rubail,
  Upwork_Review_Ehud_Sourjon,
  Upwork_Review_MO_Ali,
  linkedin,
  Character_1,
  Character_2,
  Character_3,
  Character_4,
  founder,
  co_founder
}
